/**
 * Created by RSchweber-Koren on 5/12/2017.
 */

class SubscriptionWorkflowError extends Error {
    constructor({errorMessage, errorData = null}) {
        super(errorMessage);
        this.name = "SubscriptionWorkflowError";
        this.errorData = errorData;
    }
}

export default SubscriptionWorkflowError;


//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/SubscriptionWorkflowError.js
// module id = qwAQ
// module chunks = 1